<!-- TEMPLATE -->
<template>
  <transition name="fade">
    <div v-if="showMobileMenu" class="dean-header-mobile small-only">
      <div class="dean-header-mobile-bar">
        <div class="row">
          <div class="small-10 columns">
            <div class="dean-header-mobile-top">
              <slot name="dean-header-mobile-top"></slot>
            </div>
          </div>
          <div class="small-2 columns">
            <slot name="dean-header-mobile-close"></slot>
          </div>
        </div>
      </div>
      <div class="dean-header-mobile-content">
        <slot name="dean-header-mobile-content"></slot>
      </div>
    </div>
  </transition>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
import deanIcon from './deanIcon.vue';
import deanSearchField from './deanSearchField.vue';

@Component({
  components: {
    deanIcon,
    deanSearchField
  }
})
export default class deanHeaderMobile extends Vue {
  // DATA
  showMobileMenu: boolean = true;

  // PROPS
  @Prop() value!: string;

  mounted() {
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        this.showMobileMenu = false;
      }
    });
  }

  destroyed() {
    window.removeEventListener('resize', () => {
      this.showMobileMenu = true;
    });
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN HEADER MOBILE
.dean-header-mobile {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.99);
  min-height: 100vh;
  min-width: 100%;
  z-index: 998;
}

.dean-header-mobile-bar {
  position: relative;
  height: 80px;
  z-index: 998;
  background: white;
  border: 1px solid var(--color-light-shade-2, $color-light-shade-2);
  .row,
  .column,
  .columns {
    height: 100%;
  }
}

.dean-header-mobile-search {
  padding: 9.5px 10px 9.5px 10px;
}

.dean-header-mobile-content {
  display: block;
  overflow-y: scroll;
  @include calc('height', '100vh - 78px');
  padding: 10px 0px 25px 0px;
}
</style>
